module.exports = "../fonts/viber_registration.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viber_registration.svg
// module id = 91
// module chunks = 0